/**
 * Waits for a specific DOM element to appear and clicks it,
 * but only if the window width is less than 800px.
 * 
 * @param {string} selector - The CSS selector of the element to wait for.
 * @param {number} maxWaitTime - Maximum wait time in milliseconds (default: 5000).
 * @param {number} checkInterval - Interval between checks in milliseconds (default: 100).
 */
function autoClickWhenReady(selector, maxWaitTime = 5000, checkInterval = 100) {
    if (window.innerWidth >= 800) return;

    let waited = 0;
    const interval = setInterval(() => {
        const element = document.querySelector(selector);

        if (element) {
            element.click();
            clearInterval(interval);
        }

        waited += checkInterval;
        if (waited >= maxWaitTime) {
            clearInterval(interval);
            console.warn(`Element '${selector}' not found within ${maxWaitTime / 1000} seconds.`);
        }
    }, checkInterval);
}

// Subscription app
function initializeSubscriptionUI() {
  // Set up collapsible sections toggle behavior
  function setupCollapseToggle() {
    const collapsibleSections = document.querySelectorAll('.shopify_subscriptions_app_block_label_children');

    // Hide all collapsible sections initially
    collapsibleSections.forEach(section => {
      section.style.display = 'none';
    });

    // Toggle visibility when parent label is clicked
    document.querySelectorAll('.shopify_subscriptions_app_block_label').forEach(parentLabel => {
      parentLabel.addEventListener('click', function () {
        const childSection = this.querySelector('.shopify_subscriptions_app_block_label_children');
        if (childSection) {
          childSection.style.display = (childSection.style.display === 'none') ? 'block' : 'none';
        } else {
          // Get all sibling elements of the clicked parent
          const siblingLabels = Array.from(this.parentNode.children).filter(
            sibling => sibling !== this && sibling.classList.contains('shopify_subscriptions_app_block_label')
          );

          // Hide all sibling child sections
          siblingLabels.forEach(sibling => {
            const siblingChild = sibling.querySelector('.shopify_subscriptions_app_block_label_children');
            if (siblingChild) {
              siblingChild.style.display = 'none';
            }
          });
        }
        
      });
    });

    // Prevent clicks inside collapsible sections from toggling the collapse
    collapsibleSections.forEach(section => {
      section.addEventListener('click', e => e.stopPropagation());
    });

    console.log('Collapse toggle setup completed.');
  }

  // Update 'selected' class based on checked inputs inside option containers
  function refreshSelectedStates() {
    const optionContainers = document.querySelectorAll('.shopify_subscriptions_app_block_label, .shopify_subscriptions_purchase_option_wrapper');

    optionContainers.forEach(container => {
      const hasCheckedInput = container.querySelector('input:checked') !== null;
      container.classList.toggle('selected', hasCheckedInput);
    });
  }

  // Attach change event listeners to all inputs inside option containers
  function attachInputListeners() {
    const optionContainers = document.querySelectorAll('.shopify_subscriptions_app_block_label, .shopify_subscriptions_purchase_option_wrapper');

    optionContainers.forEach(container => {
      const inputs = container.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      inputs.forEach(input => {
        input.addEventListener('change', refreshSelectedStates);
      });
    });
  }

  // Initialize all functionality
  function init() {
    setupCollapseToggle();
    refreshSelectedStates();
    attachInputListeners();
  }

  init();
}

// then initializes the subscription UI if elements exist.
function waitForSubscriptionElementAndInit(maxAttempts = 5, intervalMs = 200) {
  let attempts = 0;

  const intervalId = setInterval(() => {
    const elementsExist = document.querySelector('.shopify_subscriptions_app_block_label_children') !== null;

    if (elementsExist) {
      clearInterval(intervalId);
      initializeSubscriptionUI();
    } else if (++attempts >= maxAttempts) {
      clearInterval(intervalId);
      console.warn(`"Subscription APP" not found after ${maxAttempts} attempts. Initialization skipped.`);
    }
  }, intervalMs);
}

// Vehicle widget toggle functionality
function initializeVehicleWidgetToggle() {
  // Only run on mobile devices (width < 640px)
  if (window.innerWidth >= 640) {
    return;
  }
  
  const vehicleWidgetTitles = document.querySelectorAll('.cm_vehicle-widget_title');
  
  if (vehicleWidgetTitles.length === 0) {
    return;
  }
  
  vehicleWidgetTitles.forEach((title, index) => {
    // Find the corresponding body element first
    let vehicleWidgetBody = null;
    let parentWidget = title.closest('.cm_vehicle-widget');
    
    if (parentWidget) {
      vehicleWidgetBody = parentWidget.querySelector('.cm_vehicle-widget_body');
      
      // Hide the body by default on mobile and add smooth transitions
      if (vehicleWidgetBody) {
        vehicleWidgetBody.style.display = 'none';
        vehicleWidgetBody.style.opacity = '0';
        vehicleWidgetBody.style.maxHeight = '0';
        vehicleWidgetBody.style.overflow = 'hidden';
        vehicleWidgetBody.style.transition = 'opacity 0.3s ease, max-height 0.3s ease';
      }
    }
    
    title.addEventListener('click', function(e) {
      // Try multiple approaches to find the body element
      let vehicleWidgetBody = null;
      let parentWidget = this.closest('.cm_vehicle-widget');
      
      if (parentWidget) {
        vehicleWidgetBody = parentWidget.querySelector('.cm_vehicle-widget_body');
      } else {
        // Alternative approach: look for body in the same container or next sibling
        vehicleWidgetBody = this.parentElement.querySelector('.cm_vehicle-widget_body') || 
                          this.nextElementSibling?.classList.contains('cm_vehicle-widget_body') ? this.nextElementSibling : null;
      }
      
      if (vehicleWidgetBody) {
        // Toggle visibility with smooth animation
        if (vehicleWidgetBody.style.display === 'none') {
          // Show with smooth animation
          vehicleWidgetBody.style.display = 'block';
          // Use setTimeout to ensure display: block is applied before animating
          setTimeout(() => {
            vehicleWidgetBody.style.opacity = '1';
            vehicleWidgetBody.style.maxHeight = vehicleWidgetBody.scrollHeight + 'px';
          }, 10);
        } else {
          // Hide with smooth animation
          vehicleWidgetBody.style.opacity = '0';
          vehicleWidgetBody.style.maxHeight = '0';
          // Hide completely after animation
          setTimeout(() => {
            vehicleWidgetBody.style.display = 'none';
          }, 300);
        }
      }
    });
    
    // Add some visual feedback that the element is clickable
    title.style.cursor = 'pointer';
    title.style.userSelect = 'none';

    console.log('Vehicle widget toggle functionality initialized successfully.');
  });
}

// Wait for vehicle widget elements and initialize toggle functionality
function waitForVehicleWidgetAndInit(maxAttempts = 20, intervalMs = 500) {
  // Only run on mobile devices
  if (window.innerWidth >= 800) {
    return;
  }
  
  let attempts = 0;

  const intervalId = setInterval(() => {
    attempts++;
    
    const titleElements = document.querySelectorAll('.cm_vehicle-widget_title');
    
    if (titleElements.length > 0) {
      clearInterval(intervalId);
      new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 1000);
      }).then(() => {
        initializeVehicleWidgetToggle();
      });
    } else if (attempts >= maxAttempts) {
      clearInterval(intervalId);
    }
  }, intervalMs);
}

document.addEventListener("DOMContentLoaded", () => {
    // Collapses the Year Make Model (YMM) block by default on mobile devices.
    autoClickWhenReady(".cm_vehicle-widget_header");

    waitForSubscriptionElementAndInit();
    
    waitForVehicleWidgetAndInit();
});